
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 348 263","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.608 262.141H331.21c19.027 0 17.467-31.347 15.496-47.039-.605-4.841-3.635-11.971-6.437-15.967L196.682 16.533c-12.577-22.044-32.968-22.044-45.551 0L7.562 199.111c-2.803 3.996-5.832 11.126-6.438 15.967-1.977 15.698-3.544 47.063 15.484 47.063z","fill":"#000"}})])
          )
        }
      }
    